import { GET_JOBCARDTYPE_REQUEST, GET_JOBCARDTYPE_SUCCESS, GET_JOBCARDTYPE_FAIL, GET_VEHICLENO_REQUEST, GET_VEHICLENO_SUCCESS, GET_VEHICLENO_FAIL } from '../types/inputApiTypes'

function getJobCardTypeReducer( state = { jobCardType: [] }, action) {
    switch (action.type) {
        case GET_JOBCARDTYPE_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_JOBCARDTYPE_SUCCESS: 
            return {
                ...state,
                jobCardType: action.payload,
                isLoading: false
            }
        case GET_JOBCARDTYPE_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function getVehicleNoReducer( state = { vehicleNo: [] }, action) {
    switch (action.type) {
        case GET_VEHICLENO_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_VEHICLENO_SUCCESS: 
            return {
                ...state,
                vehicleNo: action.payload,
                isLoading: false
            }
        case GET_VEHICLENO_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

export { getJobCardTypeReducer, getVehicleNoReducer }